import Vue from "vue";
// import BootstrapVue from "bootstrap-vue";

import router from "./router";
import { createApp } from "vue";
import vco from "v-click-outside";
import VueApexCharts from "vue3-apexcharts";
import VueSweetalert2 from "vue-sweetalert2";
import VueSlideBar from "vue-slide-bar";
import { BootstrapVue, IconsPlugin, DropdownPlugin, TablePlugin } from "bootstrap-vue";
import VueEasyLightbox from "vue-easy-lightbox";
import VueClipboard from "vue3-clipboard";
import GlobalFilters from "./plugins/filters";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "../node_modules/timeline-vuejs/dist/timeline-vuejs.css";
// import VueLazyload from 'vue-lazyload'
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { Vue3ToggleButton } from "vue3-toggle-button";
import "../node_modules/vue3-toggle-button/dist/style.css";

// import '@programic/vue3-tooltip/dist/index.css';
import i18n from "./i18n";
import store from "@/state/store";
import App from "./App.vue";
// As a plugin
import VueMask from "v-mask";
import "bootstrap";

import * as VueGoogleMaps from "vue2-google-maps";
import Lightbox from "vue-easy-lightbox";
import initFacebookSdk from "./_helpers/init-facebook-sdk";
import VueMoment from "vue-moment";
import moment from "moment";
import { SimpleBar } from "simplebar-vue3";
import "moment/locale/th";
import XLSX from "xlsx";
// import dateTimeShow from "@/components/dateTimeShow";
// import VueCarousel from "vue-carousel";
import VueCarousel from "@chenfengyuan/vue-carousel";
import paymentType from "@/components/utility/payment-type";
import paymentTypeIcon from "@/components/utility/payment-type-icon";
import tabStatusCredit from "@/components/utility/tab-status-credit";
import menuBar from "@/components/utility/menubar";
import menuTopBar from "@/components/utility/menu-topbar";
import boxContent from "@/components/utility/box-content";
import boxLine from "@/components/utility/box-line";
import boxLineNowrap from "@/components/utility/box-line-nowrap";
import noData from "@/components/utility/no-data";
import dateTimeShow from "@/components/utility/dateTimeShow";
import dateFormatDate from "@/components/utility/date-format-date";
import accrodion from "@/components/utility/accrodion"
import TableSkeleton from "@/components/skeleton/table";
import CardSummary from "@/components/order/skeleton/card-summary";




import fn from "@/helpers/utility";


import packageJson from '../package.json';



Vue.use(VueCarousel);




var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl);
});

const momentPlugin = {
  install(app) {
    // Attach moment to Vue 3 global properties, to make it globally available.
    // https://vuejs.org/guide/reusability/plugins.html#writing-a-plugin
    app.config.globalProperties.$moment = moment;
  }
};
Vue.use(momentPlugin);

Vue.use(XLSX);

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/th";
Vue.use(DatePicker);
Vue.component("DatePicker", DatePicker);

Vue.component("paymentType", paymentType);
Vue.component("paymentTypeIcon", paymentTypeIcon);
Vue.component("tabStatusCredit", tabStatusCredit);
Vue.component("menuBar", menuBar);
Vue.component("boxContent", boxContent);
Vue.component("BoxLine", boxLine);
Vue.component("menuTopBar", menuTopBar);
Vue.component("noData", noData);
Vue.component("dateTimeShow", dateTimeShow);
Vue.component("dateFormatDate", dateFormatDate);
Vue.component("boxLineNowrap", boxLineNowrap);
Vue.component("accrodion", accrodion);
Vue.component("TableSkeleton", TableSkeleton);
Vue.component("CardSummary", CardSummary);





import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);
// Vue.use(VueLazyload);
Vue.use(Vue3ToggleButton);
// Vue.use(ToggleButton);
// Vue.use(VueThailandAddress);

import { configureCompat } from "vue";
import VueHtml3pdf from "vue3-html2pdf";
Vue.use(VueHtml3pdf);
Vue.config.productionTip = false;
// import VueHtml2pdf from 'vue-html2pdf'
// Vue.use(VueHtml2pdf)

// default everything to Vue 3 behavior, and only enable compat
// for certain features

configureCompat({
  MODE: 3,
  GLOBAL_MOUNT_CONTAINER: true,
  CONFIG_DEVTOOLS: true,
  COMPILER_V_IF_V_FOR_PRECEDENCE: true,
  COMPILER_V_IF_SAME_KEY: true,
  COMPILER_V_FOR_TEMPLATE_KEY_PLACEMENT: true,
  COMPILER_SFC_FUNCTIONAL: true,
  CONFIG_IGNORED_ELEMENTS: true,
  COMPILER_INLINE_TEMPLATE: true,
  PROPS_DEFAULT_THIS: true,
  INSTANCE_DESTROY: true,
  GLOBAL_PRIVATE_UTIL: true,
  CONFIG_PRODUCTION_TIP: true,
  CONFIG_SILENT: true,
  TRANSITION_CLASSES: true,
  GLOBAL_MOUNT: true,
  GLOBAL_EXTEND: true,
  GLOBAL_SET: true,
  GLOBAL_DELETE: true,
  GLOBAL_OBSERVABLE: true,
  CONFIG_KEY_CODES: true,
  CONFIG_WHITESPACE: true,
  INSTANCE_SET: true,
  INSTANCE_DELETE: true,
  INSTANCE_EVENT_EMITTER: true,
  INSTANCE_EVENT_HOOKS: true,
  INSTANCE_CHILDREN: true,
  INSTANCE_LISTENERS: true,
  INSTANCE_SCOPED_SLOTS: true,
  INSTANCE_ATTRS_CLASS_STYLE: true,
  OPTIONS_DATA_FN: true,
  OPTIONS_DATA_MERGE: true,
  OPTIONS_BEFORE_DESTROY: true,
  OPTIONS_DESTROYED: true,
  WATCH_ARRAY: true,
  V_ON_KEYCODE_MODIFIER: true,
  CUSTOM_DIR: true,
  ATTR_FALSE_VALUE: true,
  ATTR_ENUMERATED_COERCION: true,
  TRANSITION_GROUP_ROOT: true,
  COMPONENT_ASYNC: true,
  COMPONENT_FUNCTIONAL: true,
  COMPONENT_V_MODEL: true,
  RENDER_FUNCTION: true,
  FILTERS: true,
  COMPILER_IS_ON_ELEMENT: true,
  COMPILER_V_BIND_SYNC: true,
  COMPILER_V_BIND_PROP: true,
  COMPILER_V_BIND_OBJECT_ORDER: true,
  COMPILER_V_ON_NATIVE: true,
  COMPILER_V_FOR_REF: true,
  COMPILER_NATIVE_TEMPLATE: true,
  COMPILER_FILTERS: true
});

Vue.use(configureCompat);
// Vue.use(VueLazyload)
Vue.use(Vue3ToggleButton);
// Vue.use(VueThailandAddress);
Vue.use(SimpleBar);

Vue.use(VueClipboard);

const sweetAlert2Options = {
  confirmButtonColor: fn.colorRocket(),
  cancelButtonColor: "#F6F9FB"
};
Vue.use(VueSweetalert2, sweetAlert2Options);
Vue.use(Lightbox);
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: "AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE",
//     libraries: "places"
//   },
//   installComponents: true
// });

import "@/assets/scss/app.scss";
// import GAuth from "vue-google-oauth2";
// const gauthOption = {
//   clientId: process.env.VUE_APP_GOOGLE_APP_ID,
//   scope: "profile email",
//   prompt: "consent",
//   fetch_basic_profile: true
// };
// Vue.use(GAuth, gauthOption);

// import gAuth from "vue3-google-auth";
// const $gAuth = gAuth.createGAuth({
//   clientId: process.env.VUE_APP_GOOGLE_APP_ID,
//   scope: "profile email",
//   prompt: "consent",
//   fetch_basic_profile: true
// });

moment.locale("th");
Vue.use(VueMoment);

// Vue.use(moment)
// Vue.use(VueMoment)

Vue.component(VueCarousel.name, VueCarousel);

Vue.component("vue-phone-number-input", VuePhoneNumberInput);
Vue.component("VueSlideBar", VueSlideBar);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(DropdownPlugin);
Vue.use(TablePlugin);

Vue.use(vco);
Vue.component("apexchart", VueApexCharts);
// Vue.use(Vuelidate);
Vue.use(VueSweetalert2);

Vue.use(require("vue-chartist"));
Vue.use(VueMask);

Vue.filter("toCurrency", function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  });
  return formatter.format(value).replace("$", "");
});

import { library } from "@fortawesome/fontawesome-svg-core";

import {
  // faEnvelopeOpenDollar,
  faTruck,
  faGear,
  faBox,
  faPeopleCarryBox,
  faSquarePlus,
  faFileExcel,
  faCircleDollarToSlot,
  faDesktop,
  faShuttleSpace,
  faRocket,
  faTriangleExclamation,
  faSackDollar,
  faArrowDownShortWide,
  faListUl,
  faMoneyCheckDollar,
  faBell,
  faCircleQuestion,
  faInfo,
  faCircleInfo,
  faRectangleXmark,
  faTable,
  faPen,
  faArrowDownWideShort,
  faRightFromBracket,
  faRotate,
  faCopy,
  faUser,
  faArrowsRotate,
  faCircleNotch,
  faChevronDown,
  faAnglesRight,
  faDatabase,
  faFileSignature,
  faBars,
  faDoorOpen,
  faUserGroup,
  faCoins,
  faEyeSlash,
  faEye,
  faClockRotateLeft,
  faMagnifyingGlass,
  faHeartPulse,
  faTrash,
  faWindowMaximize,
  faSpinner,
  faArrowUpFromBracket,
  faUserPlus,
  faLocationDot,
  faMoneyBillTransfer,
  faBullhorn,
  faFileLines,
  faKey,
  faShop,
  faPencil,
  faCheck,
  faXmark,
  faFloppyDisk,
  faPrint,
  faUserPen,
  faArrowRight,
  faCreditCard,
  faMapLocationDot,
  faMoneyBill1,
  faCircleExclamation,
  faPlus,
  faHouse,
  faHeartCrack,
  faArrowUpRightFromSquare,
  faTruckPickup,
  faCamera,
  faStop,
  faCheckCircle,
  faTimesCircle,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  // faEnvelopeOpenDollar,
  faTruck,
  faGear,
  faBox,
  faPeopleCarryBox,
  faSquarePlus,
  faFileExcel,
  faCircleDollarToSlot,
  faDesktop,
  faShuttleSpace,
  faRocket,
  faTriangleExclamation,
  faArrowDownShortWide,
  faListUl,
  faSackDollar,
  faMoneyCheckDollar,
  faBell,
  faCircleQuestion,
  faInfo,
  faCircleInfo,
  faRectangleXmark,
  faTable,
  faPen,
  faArrowDownWideShort,
  faRightFromBracket,
  faRotate,
  faCopy,
  faUser,
  faArrowsRotate,
  faCircleNotch,
  faChevronDown,
  faTruckPickup,
  faAnglesRight,
  faDatabase,
  faFileSignature,
  faBars,
  faDoorOpen,
  faUserGroup,
  faCoins,
  faEyeSlash,
  faEye,
  faClockRotateLeft,
  faMagnifyingGlass,
  faHeartPulse,
  faWindowMaximize,
  faTrash,
  faSpinner,
  faArrowUpFromBracket,
  faUserPlus,
  faLocationDot,
  faMoneyBillTransfer,
  faBullhorn,
  faFileLines,
  faKey,
  faShop,
  faPencil,
  faCheck,
  faXmark,
  faFloppyDisk,
  faPrint,
  faUserPen,
  faArrowRight,
  faCreditCard,
  faMapLocationDot,
  faMoneyBill1,
  faCircleExclamation,
  faPlus,
  faHouse,
  faHeartCrack,
  faArrowUpRightFromSquare,
  faCamera,
  faStop,
  faCheckCircle,
  faTimesCircle,
  faTrashAlt,
);

let startApp = createApp(App)
  .use(router)
  .use(store)
  .use(i18n)
  .use(VueEasyLightbox)
  .component("font-awesome-icon", FontAwesomeIcon)
  .use(VueClipboard, {
    autoSetContainer: true,
    appendToBody: true
  });

startApp.config.globalProperties.$filters = {
  ...GlobalFilters
};

startApp.mount("#app");

// startApp.config.errorHandler = function (err, vm, info) {
//   airbrake.notify({
//     error: err,
//     params: {info: info}
//   });
// }

Vue.directive("scroll", {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener("scroll", f);
      }
    };
    window.addEventListener("scroll", f);
  }
});

// Vue.directive('click-outside', {
//   bind: function (el, binding, vnode) {
//     el.clickOutsideEvent = function (event) {
//       // here I check that click was outside the el and his children
//       if (!(el == event.target || el.contains(event.target))) {
//         // and if it did, call method provided in attribute value
//         // vnode.context[binding.expression](event);
//         // console.log(event.target,'event');
//       }
//     };
//     document.body.addEventListener('click', el.clickOutsideEvent)
//   },
//   unbind: function (el) {
//     document.body.removeEventListener('click', el.clickOutsideEvent)
//   },
// });

// wait for facebook sdk to start app
initFacebookSdk().then(startApp);
// Vue.prototype.$facebook = window.FB

// function startApp() {
//   new Vue({
//     router,
//     store,
//     i18n,
//     render: (h) => h(App),
//   }).$mount("#app");
// }